import VantaBase from "./_base.js";
import { color2Rgb } from "./helpers.js";
export default class CanvasBase extends VantaBase {
  clear() {
    const c = this.context;
    c.clearRect(0, 0, this.width, this.height);
    if (this.options.backgroundAlpha > 0) {
      c.fillStyle = color2Rgb(
        this.options.backgroundColor,
        this.options.backgroundAlpha,
      );
      c.fillRect(0, 0, this.width, this.height);
    }
  }
}
CanvasBase.prototype.canvas2D = true;
